import { AsyncPipe, DecimalPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { Observable } from 'rxjs';
import { AgilityButtonComponent } from '@agility-components/agility-button/agility-button.component';
import { AgilityLoadingSpinnerComponent } from '@agility-components/agility-loading-spinner/agility-loading-spinner.component';
import { LabelCount, WorkflowType } from 'src/app/graphql/generated';

export type WorkflowPanelId =
  WorkflowType.FUNDING | WorkflowType.COLLATERAL | WorkflowType.SETTLEMENT;

export interface SidebarWorkflowPanelConfig {
  id: WorkflowPanelId;
  label: string;
  icon: string;
  route: string;
  toggleAriaLabel: string;
  counts$: Observable<LabelCount[]>;
  showHighPriorityIndicator: boolean;
}

@Component({
  standalone: true,
  selector: 'app-sidebar-workflow-panel',
  imports: [
    AgilityButtonComponent,
    AgilityLoadingSpinnerComponent,
    AsyncPipe,
    DecimalPipe,
    RouterModule,
    TooltipModule,
  ],
  templateUrl: './sidebar-workflow-panel.component.html',
  styleUrls: ['./sidebar-workflow-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarWorkflowPanelComponent {
  panel = input.required<SidebarWorkflowPanelConfig>();
  isOpen = input.required<boolean>();
  isLoading = input.required<Observable<boolean>>();

  readonly panelToggle = output<void>();

  get headingId(): string {
    return `sidebar-${this.panel().id}-nav-heading`;
  }

  get contentId(): string {
    return `sidebar-${this.panel().id}-panel-content`;
  }

  getLinkQueryParams(anchor: LabelCount): Record<string, string | boolean> {
    switch (this.panel().id) {
      case WorkflowType.FUNDING:
        return { wireStatus: anchor.description ?? '' };
      case WorkflowType.COLLATERAL:
        return anchor.label === 'readyToShipEnote'
          ? { workflowStatus: anchor.label, eNote: true }
          : { workflowStatus: anchor.label };
      case WorkflowType.SETTLEMENT:
        return { workflowStatus: anchor.label };
    }
  }
}
